import { injectGlobal } from 'styled-components'

import colors from './colors'

injectGlobal`
  .Toastify__toast-container {
    bottom: 1rem !important;
    z-index: 99999;
  }
  .Toastify__toast {
    background: ${colors.black} !important;
    padding: .5rem 1rem !important;
    border-radius: 100px !important;
    min-height: 0 !important;
    margin: 1rem;
  }
  .Toastify__toast-body {
    color: white !important;
    margin: 0 !important;
  }

  .Toastify__toast-body .close-x {
    font-weight: 500;
  }

  .Toastify__toast .toast-button {
    background: ${colors.toastBg};
    padding: 0 .25rem;
    border-radius: .25rem;
    display: inline-block;
    margin: 0 .25rem;
  }

  /* transition */
  @keyframes toastIn {
    from {
      opacity: 0;
      transform: translateY(30px);
    }

    to {
      opacity: 1;
    }
  }

  .toastIn {
    animation-name: toastIn;
  }

  @keyframes toastOut {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
      transform: translateY(30px);
    }
  }

  .toastOut {
    animation-name: toastOut;
  }
`



// WEBPACK FOOTER //
// ./src/styles/toasts.js